<template>
  <div
    class="w-auto h-auto collapse navbar-collapse max-height-vh-100 h-100"
    id="sidenav-collapse-main"
  >
    <ul class="navbar-nav">
      <li class="nav-item" style="z-index: 1099;">
        <sidenav-collapse navText="Sandbox" :to="{ name: 'Generate' }">
          <template #icon>
            <document />
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item" style="z-index: 1099;">
        <sidenav-collapse navText="Connections" :to="{ name: 'Connections' }">
          <template #icon>
            <Switches />
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse navText="AI Database" :to="{ name: 'Database' }">
          <template #icon>
            <Brain />
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse v-show="isManager === true" navText="Dashboard" :to="{ name: 'Dashboard' }">
          <template #icon>
            <spaceship />
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse navText="Tutorials" :to="{ name: 'Tutorials' }">
          <template #icon>
            <CustomerSupport />
          </template>
        </sidenav-collapse>
      </li>
    </ul>
  </div>

</template>

<script>
import SidenavCollapse from "./SidenavCollapse.vue";
import Document from "../../components/Icon/Document.vue";
import Brain from "../../components/Icon/Brain.vue";
import Spaceship from "../../components/Icon/Spaceship.vue";
import CustomerSupport from "../../components/Icon/CustomerSupport.vue";
import Switches from "../../components/Icon/Switches.vue";
import HTFetch from "../../llamadas/HTFetch"

export default {
  name: "SidenavList", 
  props: {
    cardBg: String,
  },

  data() {
    return {
      title: "Soft UI Dashboard PRO",
      controls: "dashboardsExamples",
      isActive: "active",
      isManager: false,
      isInserter: false,
      llamada: new HTFetch(),
    };
  },

  components: {
    SidenavCollapse,
    Brain,
    Document,
    Spaceship,
    CustomerSupport,
    Switches
  },

  mounted() {
    if (localStorage.manager === 'true') {
      this.isManager = true
    }

    if (localStorage.inserter === 'true') {
      this.isInserter = true
    }
  },

  methods: {
    getRoute() {
      const routeArr = this.$route.path.split("/");
      return routeArr[1];
    },

    
  },
};
</script>
